import tr from './tr'
import en from './en'
import de from './de'

const messages: Record<string, { translation: Record<string, string> }> = {
  tr: { translation: tr },
  en: { translation: en },
  de: { translation: de },
}

export default messages
